const baseConfig = {
  url: process.env.REACT_APP_BASE_URL,
  frontendUrl: process.env.REACT_APP_FRONTEND_URL,
  awsS3Url: process.env.REACT_APP_AWS_S3_URL,
  sigaUrl: process.env.REACT_APP_SIGA_URL,
}

export default baseConfig
